import { CookiePolicy } from './CookiesPolicy';

export default props => new CookiePolicy({
	...props,
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CookiesPolicy4/index.js